export type IInventoryCountStatusChangeAction = 'next' | 'prev';
